
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import './CustomTooltip.scss';

interface CustomTooltipProps {
  id?: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
  variant?: 'dark' | 'light' | 'success' | 'warning' | 'error' | 'info';
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ 
  id = 'chatbot-tooltip', 
  place = 'top',
  variant = 'light'
}) => {
  return (
    <ReactTooltip
      id={id}
      place={place}
      variant={variant}
      className="custom-chatbot-tooltip"
      delayShow={200}
      offset={10}
      opacity={1}
      noArrow={false}
      style={{
        zIndex: 99999, // Ensure it's on top of everything including overlays
      }}
    />
  );
};

export default CustomTooltip;
